<ng-container *ngIf="tourActive$ | async">
  <div class="tour-overlay" role="dialog" aria-modal="true" aria-label="Product Tour">
    <div class="tour-overlay__backdrop" (click)="exit()"></div>
    <div class="tour-overlay__content">
      <calsoft-tour-modal (exitTour)="exit()"></calsoft-tour-modal>
    </div>
  </div>
</ng-container>
